import { objectKeysCamelToSnakeCase } from 'core/utils';
import { ICustomerQuotePart, ICustomerQuotePartReorderData } from 'quotes/types';

export const onRowsReorder =
  (
    reorderQuoteParts: (
      data: ICustomerQuotePartReorderData
    ) => Promise<{ success: boolean; quoteParts: ICustomerQuotePart[] }>,
    onSumbitSuccess: () => void
  ) =>
  async (diffRows: ICustomerQuotePart[]) => {
    const data = {
      quoteParts: diffRows.map((row: ICustomerQuotePart) => ({
        id: row.masterQuotePartId ? row.masterQuotePartId : row.id,
        line: row.line,
      })),
    };

    const { success, quoteParts } = await reorderQuoteParts(objectKeysCamelToSnakeCase(data));

    if (success) {
      onSumbitSuccess();
    }

    return { success, updatedRows: success ? quoteParts.sort((a, b) => a.line - b.line) : [] };
  };
